import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHookstate } from "@hookstate/core";
import {
    SITEID_GLOBAL_STATE
} from "globalStore/globalStore";
import { useTranslation } from "react-i18next";
import { PEOPLE_SERVICES } from "redux/reduxToolkitServices/_commonServices/peopleServices";
import '@progress/kendo-theme-default/dist/all.css';
import {
    ModalTitle,
    ModalButton,
} from "pages/People/PeopleStyled";
import ModalCloseIcon from "assets/svgIcons/ModalCloseIcon";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import PeopleAlertModal from "../peopleAlertModal";
import { MultiSelect } from "@progress/kendo-react-dropdowns";

const AddPeopleModal = React.memo(({ gpsiCarId, addPeopleModalOpen, setAddPeopleModalOpen }) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const modalRef = useRef(null);

    const { getPeopleData, getVehicleAssignedIdsData } = useSelector((state) => state.peopleReducers) || [];

    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

    const [assignedPeople, setAssignedPeople] = useState([]);
    const [currentSelectedItems, setCurrentSelectedItems] = useState([]);
    const [shouldSaveAddButtonBeDisabled, setShouldSaveAddButtonBeDisabled] = useState(true);
    const [openPeopleDiscardChangesModalOpen, setOpenPeopleDiscardChangesModalOpen] = useState(false);

    useEffect(() => {
        if(gpsiCarId > 0) {
            dispatch(PEOPLE_SERVICES.getVehicleAssignedIdsByGpsiCarIdService(gpsiCarId, siteId.get()));
        }
    }, [gpsiCarId]);

     useEffect(() => {
            if (getVehicleAssignedIdsData && getPeopleData) {
                var people = getPeopleData.filter(x => getVehicleAssignedIdsData?.PersonIds.includes(x.PersonId));
                setAssignedPeople(people);
                setCurrentSelectedItems(people);
            }
        }, [getVehicleAssignedIdsData, getPeopleData]);

    const assignPeople = () => {
        let request = {
            SiteId: siteId.get(),
            GpsiCarId: gpsiCarId,
            PersonIds: currentSelectedItems.map(x => x.PersonId)
        };

        dispatch(PEOPLE_SERVICES.assignPeopleService(request));

        closeAddPersonModal();      
    }

    const closeAddPersonModal = () => {
        setAssignedPeople([]);
        setCurrentSelectedItems([]);
        setAddPeopleModalOpen(false);
        setShouldSaveAddButtonBeDisabled(true);
        setOpenPeopleDiscardChangesModalOpen(false);
    }

    const openPeopleDiscardChangesModal = () => {
        let assignedPeopleIds = assignedPeople.map(x => x.PersonId).sort();
        let currentPeopleIds = currentSelectedItems.map(x => x.PersonId).sort();

        const arraysAreEqual = assignedPeopleIds.length === currentPeopleIds.length &&
            assignedPeopleIds.every((id, index) => id === currentPeopleIds[index]);

        if (!arraysAreEqual) {
            setOpenPeopleDiscardChangesModalOpen(true);
        } else {
            closeAddPersonModal();
        }
    }

    const closeAlertModal = () => {
        setOpenPeopleDiscardChangesModalOpen(false);
    }

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: '#ffffff',
        border: '2px solid #ccc',
        boxShadow: 24,
        p: 4,
    };

    return (<>  
                <Modal 
                    open={addPeopleModalOpen}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description">
                        <Box sx={modalStyle} ref={modalRef}>
                        <ModalTitle>
                                <div>{t("Add_People")}</div>

                                <div style={{display: 'flex', justifyContent: 'flex-end', cursor: 'pointer'}} onClick={openPeopleDiscardChangesModal}>
                                    <ModalCloseIcon width={18} height={18} color="#fff" />
                                </div>
                            </ModalTitle> 

                            <div style={{ width: 300 }}>
                                <MultiSelect
                                    data={getPeopleData}
                                    textField="FullName"
                                    dataItemKey="PersonId"
                                    value={currentSelectedItems}
                                    onChange={(e) => { setCurrentSelectedItems(e.value); setShouldSaveAddButtonBeDisabled(false); } }
                                    placeholder={t("Select_People")}
                                    popupSettings={{ appendTo: modalRef.current, animate: false }}
                                />
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'flex-end', fontWeight: 'bold', margin: '30px 0px 30px 0px' }}>
                                {t("Total_Assigned_Modal")} {assignedPeople?.TotalNumberOfAssignedUsers}
                            </div>

                            <ModalButton>
                                <button 
                                    onClick={openPeopleDiscardChangesModal} 
                                    style={{ marginRight: 10, height: 35, padding: 10,  backgroundColor: '#ccc', color: 'white', border: 'solid 1px #ccc' }}>
                                        {t("Cancel")}
                                </button>
                                <button 
                                    disabled={shouldSaveAddButtonBeDisabled}
                                    onClick={assignPeople}
                                    style={shouldSaveAddButtonBeDisabled ? { height: 35, padding: 10,  backgroundColor: '#ccc', color: 'white', border: 'solid 1px #ccc', cursor: "not-allowed	"  } : { height: 35, padding: 10, backgroundColor: '#bc9b6a', color: 'white', border: 'solid 1px #ccc' }}>
                                        {t("Save")}
                                </button>
                            </ModalButton>
                        </Box>
                </Modal>
                <PeopleAlertModal
                                 openPeopleAlertModalOpen={openPeopleDiscardChangesModalOpen} 
                                 yesCallbackFunction={() => closeAddPersonModal()}
                                 noCallbackFunction={() => closeAlertModal()}
                                 title={t("Confirm_cancel")}
                                 content={t("Are_You_Sure_You_Want_To_Discard_Changes") + "?"} 
                                 loading={false}
                                 isMessageOnly={false} />
        </> 
    );
});

export default AddPeopleModal;
